import ContactDetailsSection from "../components/contact/ContactDetailsSection";
import ContactFinalCta from "../components/contact/ContactFinalCta";
import ContactFormSection from "../components/contact/ContactFormSection";
import ContactHero from "../components/contact/ContactHero";
import ContactLocationSection from "../components/contact/ContactLocationSection";
import ContactQuickConnectSection from "../components/contact/ContactQuickConnectSection";
import ContactReassuranceSection from "../components/contact/ContactReassuranceSection";
import SeoHead from "../components/common/SeoHead";
import { contactPageData } from "../data/contactData";

function ContactPage() {
  return (
    <>
      <SeoHead
        title={contactPageData.seo.title}
        description={contactPageData.seo.description}
        path="/contact"
        keywords={[
          "contact study abroad consultant",
          "book free counselling",
          "overseas education inquiry form",
          "study abroad expert support"
        ]}
      />

      <ContactHero />
      <ContactDetailsSection />
      <ContactQuickConnectSection />
      <ContactFormSection />
      <ContactLocationSection />
      <ContactReassuranceSection />
      <ContactFinalCta />
    </>
  );
}

export default ContactPage;
